<template src="../templates/normal_fcont_132.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import InfoMachineTranslation from '../components/InfoMachineTranslation'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink';
import AppDownloadiPrint from '../components/AppDownloadiPrint'
import AppDownloadSmartPanel from '../components/AppDownloadSmartPanel'
import AppDownloadCreative from '../components/AppDownloadCreative'

import { Carousel,Slide } from 'uiv'

export default {
  name: 'app',
  components: {
    LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,
    FuncSearchGalleryQR,InfoMachineTranslation,
    AppDownloadiPrint,AppDownloadSmartPanel,AppDownloadCreative
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['132-1'],
    meta: [
      { name: 'description', content: this.$store.state.messages.messages['132-2']}
    ]};
  }
  
};
</script>
<style >
</style>

